import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ToastContainer } from "react-toastify";
import { successToast } from "../../../helpers/Notification";
import { mapDispatchToProps } from "../../../store/helpers/mapDispatch";
import { mapStateToProps } from "../../../store/helpers/mapState";
import MeetingDetailsComponent from "../../../components/Meetings/MeetingDetails";
import { useParams } from "react-router-dom";
import CreateMinutesDialog from "./createMinutesDialog";

const MeetingDetails = (props) => {
  const {
    successMessage,
    errorMessage,
    UpdateMeeting,
    SearchStructure,
    location,
    socket,
    ranks,
    systemSettings,
    loggedUser,
    users,
    GetUsersByStructure,
    GetAllStructure,
    GetAllChildren,
    structure,
    GetSameLevelStructure,
    MeetingDetails,
    GetEmployees,
    GetUsersByRole,
    meeting,
    settings,
    ListAllProjects,
    GetAllResources,
    resources
  } = props;
  const [status, setStatus] = useState();
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [searchStructure, setSearchStructure] = useState([]);
  const [owners, setOwners] = useState([]);
  const [content, setContent] = useState();
  const [snack, setSnack] = useState(false);
  const [files, setFiles] = useState([]);
  const [selectedRoles, setSelectedRoles] = React.useState([]);
  const [openCreateMinutes, setOpenCreateMinutes] = React.useState(false);

  const handleCloseCreateMinutesDialog = () => setOpenCreateMinutes(false);

  const [selectedEmployees, setSelectedEmployees] = React.useState(
    []
  );
  const [category, setCategory] = React.useState();
  const { meetingId } = useParams();
  useEffect(() => {
    MeetingDetails(meetingId);
    ListAllProjects();
    GetAllResources();
  }, [MeetingDetails, meetingId]);

  useEffect(() => {
    if (meeting && meeting?.status === "completed") {
      setOpenCreateMinutes(meeting?.hasMinutes ? false : true)
    }
  }, [meeting, meeting?.status])

  useEffect(() => {
    if (errorMessage) {
      setSnack(true);
    }
  }, [errorMessage]);

  const updateUser = async () => {
    let temp1 = [];

    for (let i = 0; i < selectedRoles.length; i++) {
      const userFound = await GetUsersByRole(selectedRoles[i].id);
      if (userFound.length > 0) {
        for (let i = 0; i < userFound.length; i++) {
          if (!temp1.includes(userFound[i])) {
            temp1.push(userFound[i]);
          }
          setSelectedUsers(temp1);
        }
      }
    }
  };
  useEffect(() => {
    updateUser().then();
  }, [selectedRoles]);
  //add users on the list
  const onSelectUser = (user) => {
    for (let init = 0; init < user.length; init++) {
      selectedUsers.push(user[init]);
    }
  };

  //remove user on the list
  const removeUser = (user) => {
    let array = [...selectedUsers];
    let index = array.indexOf(user);
    if (index !== -1) {
      array.splice(index, 1);
      setSelectedUsers(array);
    }
  };

  const onSelectRole = async (role) => {
    let temp = [...selectedRoles];
    temp = role;
    setSelectedRoles(temp);
  };
  //remove role on the list
  const removeRole = (role) => {
    let array = [...selectedRoles];
    let index = array.indexOf(role);
    if (index !== -1) {
      array.splice(index, 1);
      setSelectedRoles(array);
    }
  };
  const onSubmit = async () => {
    let participantsData = [];
    // Add participants
    owners.forEach((owner) => {
      let allRequester = {};
      for (let init = 0; init < owner.length; init++) {
        allRequester = {
          ...allRequester,
          [owner[init].name]: owner[init].value,
        };
      }
      participantsData.push(allRequester);
    });
    const info = {
      status,
      // participants: participantsData,
      participants: selectedEmployees,
      id: meeting.id ?? location?.state?.id,
      start: meeting.start ?? location?.state?.start,
      end: meeting.end ?? location?.state?.end,
      venue: meeting.venue ?? location?.state?.venue,
      duration: meeting.duration ?? location?.state?.duration,
      roomId: meeting.roomId ?? location?.state?.roomId,
      name: meeting.name ?? location?.state?.name,
      agenda: meeting.agenda ?? location?.state?.agenda,
      reminder: meeting.reminder ?? location?.state?.reminder,
      content,
      files,
    };

    const response = await UpdateMeeting(info, socket);
    if (response === 200) {
      MeetingDetails(meeting.id ?? location?.state?.id);
      setSelectedUsers([]);
      setOwners([]);
      setSelectedRoles([]);
      setSelectedEmployees([]);
      setCategory("");
    }
  };
  return (
    <div className="w-full mb-12 px-4">
      {successMessage ? successToast(successMessage) : ""}
      <ToastContainer />
      <CreateMinutesDialog
        open={openCreateMinutes}
        handleClose={handleCloseCreateMinutesDialog}
        meeting={meeting} />
      <MeetingDetailsComponent
        ranks={ranks}
        GetEmployees={GetEmployees}
        selectedRoles={selectedRoles}
        category={category}
        selectedEmployees={selectedEmployees}
        setSelectedEmployees={setSelectedEmployees}
        setCategory={setCategory}
        settings={settings}
        meeting={meeting ?? location}
        SearchStructure={(s) => SearchStructure(s, false)}
        UpdateMeeting={UpdateMeeting}
        status={status}
        setStatus={setStatus}
        onSubmit={onSubmit}
        loggedUser={loggedUser}
        GetSameLevelStructure={GetSameLevelStructure}
        GetAllStructure={GetAllStructure}
        GetUsersByStructure={GetUsersByStructure}
        GetAllChildren={GetAllChildren}
        users={users}
        owners={owners}
        setOwners={setOwners}
        onSelectUser={onSelectUser}
        removeUser={removeUser}
        structure={structure}
        searchStructure={searchStructure}
        setSearchStructure={setSearchStructure}
        selectedUsers={selectedUsers}
        setContent={setContent}
        content={content}
        errorMessage={errorMessage}
        setSnack={setSnack}
        snack={snack}
        setDocument={setFiles}
        onSelectRole={onSelectRole}
        removeRole={removeRole}
        MeetingDetails={MeetingDetails}
        GetAllResources={GetAllResources}
        resources={resources?.data}
        systemSettings={systemSettings}
      />
    </div>
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(MeetingDetails);
